import React from "react";

function reportsSVGNew({
  isActive, 
  activeColor = "#232323",
  inactiveColor = "#868686" }: 
  { isActive: boolean; activeColor?: string; inactiveColor?: string; }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 22 22"
      fill={isActive ? activeColor : inactiveColor}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4 7.66667V3.30667C13.0391 3.53733 13.6271 3.89267 14.1255 4.36667L16.5643 6.69067C17.0627 7.16467 17.4358 7.72467 17.678 8.33333H13.1C12.7136 8.33333 12.4 8.034 12.4 7.66667ZM18 9.99V15.6667C18 17.5047 16.4299 19 14.5 19H7.5C5.5701 19 4 17.5047 4 15.6667V6.33333C4 4.49533 5.5701 3 7.5 3H10.6605C10.7746 3 10.8873 3.00867 11 3.016V7.66667C11 8.76933 11.9422 9.66667 13.1 9.66667H17.9832C17.9909 9.774 18 9.88133 18 9.99ZM8.9 15C8.8958 14.128 7.5042 14.1287 7.5 15V16.3333C7.5042 17.2053 8.8958 17.2047 8.9 16.3333V15ZM11.7 11.6667C11.6958 10.7947 10.3042 10.7953 10.3 11.6667V16.3333C10.3042 17.2053 11.6958 17.2047 11.7 16.3333V11.6667ZM14.5 13.6667C14.4958 12.7947 13.1035 12.7953 13.1 13.6667V16.3333C13.1042 17.2053 14.4965 17.2047 14.5 16.3333V13.6667Z"
        fill={isActive ? activeColor : inactiveColor}
      />
    </svg>
  );
}

export default reportsSVGNew;
